module.exports = __webpack_public_path__ + "img/empty.3a19f63a.png";